function toggleScienceSeries(button) {
  const item = button.closest('.hf-accordion-item');
  const content = item.querySelector('.accordion-collapse');
  const body = item.querySelector('.accordion-body');
  const icon = button.querySelector('.science-series-icon');

  const expanded = button.getAttribute('aria-expanded') === 'true';

  document.querySelectorAll('#main-content .hf-accordion-item').forEach((accordionItem) => {
    const otherButton = accordionItem.querySelector('.hf-accordion-button');
    const otherContent = accordionItem.querySelector('.accordion-collapse');
    const otherBody = accordionItem.querySelector('.accordion-body');
    const otherIcon = accordionItem.querySelector('.science-series-icon');

    if (accordionItem !== item) {
      otherButton.classList.add('collapsed');
      otherButton.setAttribute('aria-expanded', 'false');
      otherContent.style.display = 'none';
      otherBody.classList.remove('active');

      otherIcon.classList.remove('fa-chevron-up');
      otherIcon.classList.add('fa-chevron-down');
    }
  });

  if (expanded) {
    button.classList.add('collapsed');
    button.setAttribute('aria-expanded', 'false');
    content.style.display = 'none';
    body.classList.remove('active');

    icon.classList.remove('fa-chevron-up');
    icon.classList.add('fa-chevron-down');

  } else {
    button.classList.remove('collapsed');
    button.setAttribute('aria-expanded', 'true');
    content.style.display = 'block';
    body.classList.add('active');

    icon.classList.remove('fa-chevron-down');
    icon.classList.add('fa-chevron-up');
  }
}

  // document.addEventListener('DOMContentLoaded', function () {
  //   document.querySelectorAll('#main-content .hf-accordion-item .accordion-collapse').forEach((content, index) => {
  //     content.style.display = index === 0 ? 'block' : 'none';
  //   });

  //   document.querySelectorAll('#main-content .hf-accordion-item .hf-accordion-button').forEach((button, index) => {
  //     if (index === 0) {
  //       button.classList.remove('collapsed');
  //       button.setAttribute('aria-expanded', 'true');
  //     } else {
  //       button.classList.add('collapsed');
  //       button.setAttribute('aria-expanded', 'false');
  //     }
  //   });
  // });

  window.addEventListener('scroll', function () {
    const article = document.getElementById('article-content');
    const progress = document.getElementById('reading-progress');

    if (!article || !progress) return;

    const articleTop = article.offsetTop;
    const articleHeight = article.offsetHeight;
    const windowHeight = window.innerHeight;
    const scrolled = window.scrollY - articleTop;
    const totalScroll = articleHeight - windowHeight;

    if (scrolled > 0 && scrolled < totalScroll) {
      const percentage = (scrolled / totalScroll) * 100;
      progress.style.width = percentage + '%';
    } else if (scrolled <= 0) {
      progress.style.width = '0%';
    } else {
      progress.style.width = '100%';
    }
  });
  // Science Series search: filters every article, not just the current page.
  // All articles (with their full text) come from the science-series-search-index
  // section, fetched the first time someone searches.
  (function () {
    const root = document.querySelector('[data-science-search]');
    if (!root) return;

    const input = root.querySelector('[data-science-search-input]');
    const status = root.querySelector('[data-science-search-status]');
    const results = document.querySelector('[data-science-search-results]');
    const list = document.querySelector('[data-science-search-list]');

    let itemsPromise = null;
    let debounce = null;

    function loadItems() {
      if (!itemsPromise) {
        const url = window.location.pathname + '?section_id=science-series-search-index';
        itemsPromise = fetch(url)
          .then((response) => {
            if (!response.ok) throw new Error('Search index request failed: ' + response.status);
            return response.text();
          })
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const items = Array.from(doc.querySelectorAll('.science-series-item'));
            items.forEach((item) => {
              item.hidden = true;
              results.appendChild(item);
            });
            return items;
          })
          .catch((error) => {
            itemsPromise = null;
            throw error;
          });
      }
      return itemsPromise;
    }

    function setQueryParam(query) {
      const url = new URL(window.location.href);
      if (query) {
        url.searchParams.set('q', query);
      } else {
        url.searchParams.delete('q');
      }
      window.history.replaceState(null, '', url);
    }

    function showList() {
      results.hidden = true;
      list.hidden = false;
      status.textContent = '';
    }

    function search(rawQuery) {
      const query = rawQuery.trim();
      setQueryParam(query);

      if (!query) {
        showList();
        return;
      }

      const terms = query.toLowerCase().split(/\s+/);
      status.textContent = 'Searching…';

      loadItems()
        .then((items) => {
          // Ignore results for a query the visitor has already typed past
          if (input.value.trim() !== query) return;

          const titleMatches = [];
          const textMatches = [];

          items.forEach((item) => {
            const text = item.dataset.search || '';
            const title = item.dataset.title || '';
            const matches = terms.every((term) => text.includes(term));
            item.hidden = !matches;
            if (!matches) return;
            (terms.every((term) => title.includes(term)) ? titleMatches : textMatches).push(item);
          });

          // Articles whose title matches come first
          titleMatches.concat(textMatches).forEach((item) => results.appendChild(item));

          const count = titleMatches.length + textMatches.length;
          status.textContent = count
            ? count + (count === 1 ? ' article' : ' articles') + ' found for “' + query + '”'
            : 'No articles found for “' + query + '”';

          list.hidden = true;
          results.hidden = false;
        })
        .catch(() => {
          status.textContent = 'Search is unavailable right now. Please try again.';
        });
    }

    input.addEventListener('input', () => {
      clearTimeout(debounce);
      debounce = setTimeout(() => search(input.value), 200);
    });

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && input.value) {
        input.value = '';
        search('');
      }
    });

    // Start loading the index when the visitor shows intent to search
    input.addEventListener('focus', () => loadItems().catch(() => {}), { once: true });

    const initialQuery = new URLSearchParams(window.location.search).get('q');
    if (initialQuery) {
      input.value = initialQuery;
      search(initialQuery);
    }
  })();

  // Science Series article sharing: copy link, and the device share menu.
  // "Forward to a Friend" is a plain mailto: link and needs no script.
  (function () {
    const shares = document.querySelectorAll('[data-science-share]');
    if (!shares.length) return;

    function copyText(text) {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text);
      }

      // Older browsers / non-https: copy through a temporary field
      return new Promise((resolve, reject) => {
        const field = document.createElement('textarea');
        field.value = text;
        field.setAttribute('readonly', '');
        field.style.position = 'fixed';
        field.style.opacity = '0';
        document.body.appendChild(field);
        field.select();
        const copied = document.execCommand('copy');
        field.remove();
        copied ? resolve() : reject(new Error('Copy failed'));
      });
    }

    shares.forEach((share) => {
      const copyButton = share.querySelector('[data-share-copy]');
      const copyLabel = share.querySelector('[data-share-copy-label]');
      const nativeButton = share.querySelector('[data-share-native]');
      const status = share.querySelector('[data-share-status]');
      let resetTimer = null;

      copyButton.addEventListener('click', () => {
        const url = share.dataset.copyUrl;

        copyText(url)
          .then(() => {
            copyLabel.textContent = 'Link Copied';
            status.textContent = 'Link copied. Paste it into an email or message.';
          })
          .catch(() => {
            // Couldn't reach the clipboard: show the link so it can be copied by hand
            status.textContent = 'Copy this link: ' + url;
          })
          .finally(() => {
            clearTimeout(resetTimer);
            resetTimer = setTimeout(() => {
              copyLabel.textContent = 'Copy Link';
            }, 2500);
          });
      });

      if (navigator.share) {
        nativeButton.hidden = false;
        nativeButton.addEventListener('click', () => {
          navigator
            .share({
              title: share.dataset.shareTitle,
              text: share.dataset.shareText,
              url: share.dataset.shareUrl,
            })
            .catch(() => {}); // closed the share menu
        });
      }
    });
  })();
